import React from 'react'
import USStates from '../../util/us-states/USStates'
import CanadaProvinces from '../../util/canada-provinces/CanadaProvinces'
import { Select as FoundationsSelect } from 'foundations-library/components'

interface StateSelectorProps {
    countryCode: string, // "CA" or "US",
    value: string, // "" or 2 capital letter abrevication (eg. "CA")
    onChange: (value: string) => void,
    disabled: boolean
}

/**
 * Select dropdown that allows the user to choose a province/state
 */
const StateSelector = ({ countryCode, value, onChange, disabled, ...props } : StateSelectorProps) : JSX.Element => {
    const options = (countryCode === 'CA' ? CanadaProvinces : USStates).map(s => ({ value: s.abbreviation, text: s.name }))
    return (
        <FoundationsSelect
            {...props}
            options={options}
            className='form-input'
            label={countryCode === 'CA' ? 'Province' : 'State'}
            disabled={disabled}
            fullWidth={true}
            onChange={value => onChange(value)}
            value={value}
        />
    )
}

export default StateSelector
